import React, { useContext, useEffect, useRef, useState } from "react";
import { HTTPResponse, SideMenuItems, ToastMessages, ToastMessageType, Values } from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import DateControl from "../../Components/DateControl";
import { CommonError_Msgs,  Last_Patient_Encounter } from "../../Helpers/HelperText";
import ErrorField from "../../Components/ErrorField";
import {  AdjustDays,  DateValid, GetChartDateStr, GetEarlierOfDate, GetEarliestDate, GetLocalStorageData, GetLoggedInUserID, GetMaxDate, IsAdmin, IsDateBefore, IsDateEmpty, IsDateInRange,   IsGreaterOrEqual, IsValid,    applySidebarState, toggleSidebar,DisplayFormat } from "../../Helpers/Utilities";
import { AppContext } from "../../Contexts/AppContextProvider";
import InfoPopUp from "../../Components/InfoPopUp";
import { clinicalCharacteristicService } from "../../WebApiServices/ClinicalCharacteristicService";
import CustomTextArea from "../../Components/CustomTextArea ";


const ClinicalCharacteristics = () => {
  const navigatePaths = {
    prevPage: "/Demographics",
    currPage: "/ClinicalCharacteristics",
    nextPage: "/TransplantCharacteristics"
  };
  const { ShowToast, ToggleLoader, HandleSessionTimeout, isSideMenuActive, setisSideMenuActive, ShowActionPopUp } = useContext(AppContext);

  const [showHideHyperlinkModal, setShowHideHyperlinkModal] = useState(false);
  const pidRef = useRef(0);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  const indexDtInit = "index date";
 
  const lastEncounterDtInit = "date of last encounter";

  const [patientType_col1, setPatientType_col1] = useState(false);
  const [patientType_col2, setPatientType_col2] = useState(false);
  const [patientType_col3, setPatientType_col3] = useState(false);
  const [patientType_col4, setPatientType_col4] = useState(false);
  const [patientLocked, setpatientLocked] = useState(false);
  const [demoBirthDate, setDemoBirthDate] = useState("");

  const [dates, setDates] = useState({
    indexDt: indexDtInit,
    indexMinus1Day: null,
    indexMinus365Days: null,
    birthDt: null,
    surveyDt: null,
    indexPlus548Days: null,
    eighteenMonthFollowUpDt: null,

    oneYr_pretransplant_start: null,
    oneYr_pretransplant_end: null,

    three_month_stabilization: null,

    post_stabilization_start: null,
    twelve_month_post_stabilization: null,

    twelve_month_post_stabilization_plusOneday: null,
    twenty_four_months_post_stabilization: null,

    endofFollowUpDate: null,
    index_date: null,
    indexDtPlus92: null,
    indexDtPlus457: null,

    six_month_post_stabilization: null,
    eighteen_month_post_stabilization: null,

    zero_to12months_before_LT_LKT: null,
    zero_to_3months_after_LT_LKT: null,
    four_to_15months_after_LT_LKT: null,
    sixteen_to_27months_after_LT_LKT: null,
    pretransplant_start_end_criteria: null,
    indexdate_threemonth_criteria: null,
    post_stabilization_twelvemonth_criteria: null,
    twelvemonth_twentyfourmonth_criteria: null,

    transplant_admissionDt: null,
    transplant_dischargeDt: null,


    most_recent_transplant_startdt: null,

    beginning_follow_up: null,
    closest_oneYr_priorIndex: false,
    closest_transplantAdmissionDt: false,
    closest_transplantDischargeDt: false,
    closest_threeMonths_afterIndex: false,
    closest_fifteenMonths_afterIndex: false,
    closest_twentysevenMonths_afterIndex: false,
    closest_twentysevenMonths_afterIndex_nutrition: false,
    closest_twentyoneMonths_afterIndex: false,
  });

  const [clinicalDetails, setClinicalDetails] = useState({
    //12
    rbl_clinical_trial: null,
    clinical_trial_start_dt: null,  //MMA trial date 
    chk_clinical_trial_dt_est: false,


    //13
    first_encounter_dt: null,
    last_encounter_dt: null,


    //14
    rbl_death: null,
    death_dt: null,
    chk_death_dt_est: false,


    //15
    chk_death_cause_mde: false,
    chk_death_cause_lt_lkt: false,
    // chk_death_cause_renal: false,
    chk_death_cause_oth: false,
    txt_death_cause_oth: "",
    rb_death_cause_unk: false,

    //16
    chk_pt_type_1yrpre_transplant_local: false,
    chk_pt_type_1yrpre_transplant_travel: false,

    chk_pt_type_3months_stabilization_local: false,
    chk_pt_type_3months_stabilization_travel: false,

    chk_pt_type_post_stabilization_local: false,
    chk_pt_type_post_stabilization_travel: false,

    chk_pt_type_12monthpost_stabilization_local: false,
    chk_pt_type_12monthpost_stabilization_travel: false,

  });
  const InitialHardErrList = {

    //12
    clinical_trial_empty: false,
    clinical_trial_dt_empty: false,
    clinical_trial_dt_invalid: false,

    //13
    first_encounter_dt_empty: false,
    first_encounter_dt_invalid: false,

    last_encounter_dt_empty: false,
    last_encounter_dt_invalid: false,

    //14
    rbl_death_dt_empty: false,
    death_dt_empty: false,
    death_dt_invalid: false,

    //15
    death_cause_empty: false,

    //16
    pre_transplant_empty: false,
    three_month_stabilization_empty: false,
    post_stabilization_empty: false,
    twelve_month_post_stabilizationEmpty: false
  };
  const [hardErrList, setHardErrList] = useState(InitialHardErrList);

  useEffect(() => {
    async function FetchData() {
      pidRef.current = GetLocalStorageData("patientId") || 0;
      if (pidRef.current !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  async function LoadData() {
    try {
      const response = await clinicalCharacteristicService.LoadData(pidRef.current);
      if (response?.status === HTTPResponse.OK) {
        const { data } = response;
        setpatientLocked(data.patientLocked);

        SetFields(data);
      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else {
          throw response.error;
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
    return null;
  }



  const SetFields = (data) => {

    setDemoBirthDate(data.clinicalCharacteristicDates.birthDate);
    setClinicalDetails((prev) => ({

      ...prev,

      //12
      rbl_clinical_trial: data.mmaTreatmentTrial || null,
      clinical_trial_start_dt: data.mmaTreatmentTrialDate || null,
      chk_clinical_trial_dt_est: data.mmaTreatmentTrialDateEstimated ? data.mmaTreatmentTrialDateEstimated : false,

      //13
      first_encounter_dt: data.patientencounterFirstDate || null,
      last_encounter_dt: data.patientencounterLastDate || null,

      //14
      rbl_death: data.patientDeath,
      death_dt: data.patientDeathDate || null,
      chk_death_dt_est: data.patientDeathDateEstimated,

      //15
      chk_death_cause_mde: data.deathcauseComplicationsmde ? data.deathcauseComplicationsmde : false,
      chk_death_cause_lt_lkt: data.deathcauseTransplantcomplications ? data.deathcauseTransplantcomplications : false,
      // chk_death_cause_renal: data.deathcauseRenalfailure,
      chk_death_cause_oth: data.deathcauseOther,
      txt_death_cause_oth: data.deathcauseOthertext || "",
      rb_death_cause_unk: data.deathcauseUnknown,

      //16
      chk_pt_type_1yrpre_transplant_local: data.patienttype1yearPretransplantLocal ? data.patienttype1yearPretransplantLocal : false,
      chk_pt_type_1yrpre_transplant_travel: data.patienttype1yearPretransplantTraveling ? data.patienttype1yearPretransplantTraveling : false,

      chk_pt_type_3months_stabilization_local: data.patienttype3monthStabilizationLocal ? data.patienttype3monthStabilizationLocal : false,
      chk_pt_type_3months_stabilization_travel: data.patienttype3monthStabilizationTraveling ? data.patienttype3monthStabilizationTraveling : false,

      chk_pt_type_post_stabilization_local: data.patienttypePoststabilizationLocal ? data.patienttypePoststabilizationLocal : false,
      chk_pt_type_post_stabilization_travel: data.patienttypePoststabilizationTraveling ? data.patienttypePoststabilizationTraveling : false,

      chk_pt_type_12monthpost_stabilization_local: data.patienttype12monthPoststabilizationLocal ? data.patienttype12monthPoststabilizationLocal : false,
      chk_pt_type_12monthpost_stabilization_travel: data.patienttype12monthPoststabilizationTraveling ? data.patienttype12monthPoststabilizationTraveling : false
     
    }));



    setDates((prev) => {
      const surveyDt = GetChartDateStr();
      const updatedData = {
        ...prev,
        birthDt: data.birthDate || prev.birthDt,
        transplant_admissionDt: data.transplantAdmissionDate || prev.transplant_admissionDt,
        transplant_dischargeDt: data.transplantDischargeDate || prev.transplant_dischargeDt,
        surveyDt: surveyDt || prev.surveyDt,
      };


      if ((data.indexDate || data.clinicalCharacteristicDates.indexDate)) {

        updatedData.index_date = data?.clinicalCharacteristicDates?.indexDate
          ? (() => {
            const [year, month, day] = data.clinicalCharacteristicDates.indexDate.split("T")[0].split("-");
            return `${month}/${day}/${year}`;
          })()
          : null;


        updatedData.indexDt = (data.indexDate || data.clinicalCharacteristicDates.indexDate);

        updatedData.indexMinus1Day = AdjustDays((data.indexDate || data.clinicalCharacteristicDates.indexDate), -1);
        updatedData.oneYr_pretransplant_end = updatedData.indexMinus1Day;


        //SYJ - 28/03/2025 - Changes => https://edotpulse.com/EditActionItem/AG-M-171
        updatedData.indexMinus365Days = AdjustDays((data.indexDate || data.clinicalCharacteristicDates.indexDate), -Values.value365);

        updatedData.most_recent_transplant_startdt = GetMaxDate(updatedData.indexMinus365Days, data.patientencounterFirstDate, data.clinicalCharacteristicDates.birthDate);
        updatedData.oneYr_pretransplant_start = updatedData.most_recent_transplant_startdt;
        updatedData.beginning_follow_up = updatedData.most_recent_transplant_startdt;

        updatedData.indexPlus548Days = AdjustDays((data.indexDate || data.clinicalCharacteristicDates.indexDate), Values.value548);
      }

      const iDtPlus91 = AdjustDays((data.indexDate || data.clinicalCharacteristicDates.indexDate), Values.value91);
      updatedData.three_month_stabilization = GetEarlierOfDate(
        iDtPlus91,
        data.mmaTreatmentTrialDate, // Use `data` directly
        data.patientencounterLastDate,
        data.patientDeathDate
      );


      const iDtPlus92 = AdjustDays((data.indexDate || data.clinicalCharacteristicDates.indexDate), Values.value92);
      updatedData.post_stabilization_start = GetEarlierOfDate(
        iDtPlus92,
        data.mmaTreatmentTrialDate,
        data.patientencounterLastDate,
        data.patientDeathDate
      );

      updatedData.indexDtPlus92 = iDtPlus92;

      const iDtPlus456 = AdjustDays((data.indexDate || data.clinicalCharacteristicDates.indexDate), Values.value456);
      updatedData.twelve_month_post_stabilization = GetEarlierOfDate(
        iDtPlus456,
        data.mmaTreatmentTrialDate,
        data.patientencounterLastDate,
        data.patientDeathDate
      );

      updatedData.indexDtPlus457 = AdjustDays((data.indexDate || data.clinicalCharacteristicDates.indexDate), Values.value457);

      const twelve_mnth_post_stabilization_plusOneday = AdjustDays(updatedData.twelve_month_post_stabilization, Values.value1);
      if (twelve_mnth_post_stabilization_plusOneday) {
        updatedData.twelve_month_post_stabilization_plusOneday = twelve_mnth_post_stabilization_plusOneday;
      }

      const iDtPlus821 = AdjustDays((data.indexDate || data.clinicalCharacteristicDates.indexDate), Values.value821);
      updatedData.twenty_four_months_post_stabilization = GetEarlierOfDate(
        iDtPlus821,
        data.mmaTreatmentTrialDate,
        data.patientencounterLastDate,
        data.patientDeathDate
      );

      updatedData.endofFollowUpDate = GetEarliestDate(
        data.mmaTreatmentTrialDate,
        data.patientencounterLastDate,
        data.patientDeathDate
      );

      updatedData.eighteenMonthFollowUpDt = GetEarliestDate(
        updatedData.indexPlus548Days,
        data.patientencounterLastDate,
        data.patientDeathDate
      );

      const iDtPlus273 = AdjustDays((data.indexDate || data.clinicalCharacteristicDates.indexDate), Values.value273);
      updatedData.six_month_post_stabilization = GetEarlierOfDate(
        iDtPlus273,
        data.mmaTreatmentTrialDate,
        data.patientencounterLastDate,
        data.patientDeathDate
      );

      const iDtPlus639 = AdjustDays((data.indexDate || data.clinicalCharacteristicDates.indexDate), Values.value639);
      updatedData.eighteen_month_post_stabilization = GetEarlierOfDate(
        iDtPlus639,
        data.mmaTreatmentTrialDate,
        data.patientencounterLastDate,
        data.patientDeathDate
      );


      const eighteen_month_post_stabilization_plusOneday = AdjustDays(updatedData.eighteen_month_post_stabilization, Values.value1);


      const patientTypecol1 = (clinicalDetails.first_encounter_dt || data.patientencounterFirstDate) && IsDateBefore((clinicalDetails.first_encounter_dt || data.patientencounterFirstDate), updatedData.indexDt);
      const patientTypecol2 = IsGreaterOrEqual(updatedData.endofFollowUpDate, updatedData.indexDt);
      const patientTypecol3 = IsGreaterOrEqual(updatedData.endofFollowUpDate, updatedData.indexDtPlus92);
      const patientTypecol4 = IsGreaterOrEqual(updatedData.endofFollowUpDate, updatedData.indexDtPlus457);

      setPatientType_col1(patientTypecol1);
      setPatientType_col2(patientTypecol2);
      setPatientType_col3(patientTypecol3);
      setPatientType_col4(patientTypecol4);


      const transplantAdmissionMinusOneDay = AdjustDays(updatedData.transplant_admissionDt, -Values.value1)
      const transplantDischargePlusOneDay = AdjustDays(updatedData.transplant_dischargeDt, Values.value1)
      const three_month_stabilizationPlusOne = AdjustDays(updatedData.three_month_stabilization, Values.value1);

      const closest_to_oneYr_priorIndex = DateValid(updatedData.beginning_follow_up, transplantAdmissionMinusOneDay)
      updatedData.closest_oneYr_priorIndex = closest_to_oneYr_priorIndex

      updatedData.closest_transplantAdmissionDt = DateValid(updatedData.beginning_follow_up, updatedData.indexDt)
      updatedData.closest_transplantDischargeDt = IsGreaterOrEqual(updatedData.endofFollowUpDate, updatedData.indexDt)
      updatedData.closest_threeMonths_afterIndex = IsGreaterOrEqual(updatedData.endofFollowUpDate, transplantDischargePlusOneDay)
      updatedData.closest_fifteenMonths_afterIndex = IsGreaterOrEqual(updatedData.endofFollowUpDate, three_month_stabilizationPlusOne)
      updatedData.closest_twentysevenMonths_afterIndex_nutrition = IsGreaterOrEqual(updatedData.endofFollowUpDate, twelve_mnth_post_stabilization_plusOneday)

      updatedData.closest_twentysevenMonths_afterIndex = IsGreaterOrEqual(updatedData.endofFollowUpDate, eighteen_month_post_stabilization_plusOneday)

      updatedData.closest_twentyoneMonths_afterIndex = IsGreaterOrEqual(updatedData.endofFollowUpDate, twelve_mnth_post_stabilization_plusOneday)

      const zeroTo12monthsBeforeLT_LKT = IsDateBefore(updatedData.beginning_follow_up, updatedData.indexDt)
      return {
        ...updatedData,
        zero_to12months_before_LT_LKT: zeroTo12monthsBeforeLT_LKT,
        pretransplant_start_end_criteria: zeroTo12monthsBeforeLT_LKT,
        zero_to_3months_after_LT_LKT: patientTypecol2,
        indexdate_threemonth_criteria: patientTypecol2,
        four_to_15months_after_LT_LKT: patientTypecol3,
        post_stabilization_twelvemonth_criteria: patientTypecol3,
        sixteen_to_27months_after_LT_LKT: patientTypecol4,
        twelvemonth_twentyfourmonth_criteria: patientTypecol4,
      };

    });


  };


  const SavePage = async (validate) => {
      try {
          if (!patientLocked) {
              //Reset Errors
              setHardErrList(InitialHardErrList);
              let isValid = validate ? Validate() : true;
              if (!isValid) {
                  setShowTopErrMsg(true);
                  return false;
              }
              let indexDtPlus92days = AdjustDays(dates.indexDt, Values.value92);
              let indexDtPlus457days = AdjustDays(dates.indexDt, Values.value457);
              let transplantDischargePlusOneDay = AdjustDays(dates.transplant_dischargeDt, Values.value1);
              let three_month_stabilizationPlusOne = AdjustDays(dates.three_month_stabilization, Values.value1);
              let twelve_mnth_post_stabilization_plusOneday = AdjustDays(dates.twelve_month_post_stabilization, Values.value1);
              let eighteen_month_post_stabilization_plusOneday = AdjustDays(dates.eighteen_month_post_stabilization, Values.value1);

              let closest_transplantDischargeDt = IsGreaterOrEqual(dates.endofFollowUpDate, dates.indexDt)
              let closest_threeMonths_afterIndex = IsGreaterOrEqual(dates.endofFollowUpDate, transplantDischargePlusOneDay)
              let closest_fifteenMonths_afterIndex = IsGreaterOrEqual(dates.endofFollowUpDate, three_month_stabilizationPlusOne)
              let closest_twentysevenMonths_afterIndex_nutrition = IsGreaterOrEqual(dates.endofFollowUpDate, twelve_mnth_post_stabilization_plusOneday)

              let closest_twentysevenMonths_afterIndex = IsGreaterOrEqual(dates.endofFollowUpDate, eighteen_month_post_stabilization_plusOneday)

              let closest_twentyoneMonths_afterIndex = IsGreaterOrEqual(dates.endofFollowUpDate, twelve_mnth_post_stabilization_plusOneday)

              let indexdate_threemonthCriteria = IsGreaterOrEqual(dates.endofFollowUpDate, dates.indexDt);
              let postStabilizationTwelvemonthCriteria = IsGreaterOrEqual(dates.endofFollowUpDate, indexDtPlus92days);
              let twelvemonthTwentyfourmonthCriteria = IsGreaterOrEqual(dates.endofFollowUpDate, indexDtPlus457days);


              setShowTopErrMsg(false);

              let clinicalCharacteristicsDatesModel = {

                  IndexDate: dates.indexDt,

                  OneyrPretransplantStartDate: dates.oneYr_pretransplant_start,

                  OneyrPretransplantEndDate: dates.oneYr_pretransplant_end,

                  ThreeMonthStabilizationDate: dates.three_month_stabilization,

                  PostStabilizationStartDate: dates.post_stabilization_start,

                  TwelveMonthPostStabilizationDate: dates.twelve_month_post_stabilization,

                  TwentyFourMonthsPostStabilizationDate: dates.twenty_four_months_post_stabilization,

                  EndoffollowupDate: dates.endofFollowUpDate,

                  SixMonthPostStabilizationDate: dates.six_month_post_stabilization,

                  EighteenMonthPostStabilizationDate: dates.eighteen_month_post_stabilization,

                  // ZeroTo12monthsBeforeLtLkt: dates.zero_to12months_before_LT_LKT,

                  // ZeroTo3monthsAfterLtLkt: dates.zero_to_3months_after_LT_LKT,

                  // FourTo15monthsAfterLtLkt: dates.four_to_15months_after_LT_LKT,

                  // SixteenTo27monthsAfterLtLkt: dates.sixteen_to_27months_after_LT_LKT,

                  //SYJ - 17/03/2025 - Fix for payload for dates not getting updated with latest value while saving in db.
                  ZeroTo12monthsBeforeLtLkt: patientType_col1,

                  ZeroTo3monthsAfterLtLkt: patientType_col2,

                  FourTo15monthsAfterLtLkt: patientType_col3,

                  SixteenTo27monthsAfterLtLkt: patientType_col4,

                  PretransplantStartEndCriteria: dates.pretransplant_start_end_criteria,

                  IndexdateThreemonthCriteria: indexdate_threemonthCriteria,

                  PostStabilizationTwelvemonthCriteria: postStabilizationTwelvemonthCriteria,

                  TwelvemonthTwentyfourmonthCriteria: twelvemonthTwentyfourmonthCriteria,

                  TransplantAdmissionDate: dates.transplant_admissionDt,

                  TransplantDischargeDate: dates.transplant_dischargeDt,

                  //SYJ - 21/03/2025 - send [12-month post-stabilization date + 1 day]
                  TwelveMonthPostStabilizationDatePlusoneday: dates.twelve_month_post_stabilization_plusOneday,

                  BegginingFollowupDate: dates.oneYr_pretransplant_start,
                  ClosestOneyrIndexDate: dates.closest_oneYr_priorIndex,
                  ClosestTransplantAdmissionDate: dates.closest_transplantAdmissionDt,
                  ClosestTransplantDischargeDate: closest_transplantDischargeDt,
                  ClosestThreeMonthIndexDate: closest_threeMonths_afterIndex,
                  ClosestFifteenMonthIndexDate: closest_fifteenMonths_afterIndex,
                  ClosestTwentysevenMonthIndexDate: closest_twentysevenMonths_afterIndex,
                  ClosestTwentysevenMonthIndexDateNutrition: closest_twentysevenMonths_afterIndex_nutrition,
                  ClosestTwentyoneMonthIndexDate: closest_twentyoneMonths_afterIndex
              }

              if (pidRef.current > 0) {
                  const payload = {
                      PatientId: pidRef.current,
                      UserId: GetLoggedInUserID(),
                      IsValidated: validate,
                      IsAdmin: IsAdmin(),
                      ClinicalCharacteristicDates: clinicalCharacteristicsDatesModel,
                      //12
                      MmaTreatmentTrial: clinicalDetails.rbl_clinical_trial,
                      MmaTreatmentTrialDate: clinicalDetails.clinical_trial_start_dt,
                      MmaTreatmentTrialDateEstimated: clinicalDetails.chk_clinical_trial_dt_est,

                      //13
                      PatientencounterFirstDate: clinicalDetails.first_encounter_dt,
                      PatientencounterLastDate: clinicalDetails.last_encounter_dt,

                      //14 
                      PatientDeath: clinicalDetails.rbl_death,
                      PatientDeathDate: clinicalDetails.death_dt,
                      PatientDeathDateEstimated: clinicalDetails.chk_death_dt_est,

                      //15
                      DeathcauseComplicationsmde: clinicalDetails.chk_death_cause_mde,
                      DeathcauseTransplantcomplications: clinicalDetails.chk_death_cause_lt_lkt,
                      // DeathcauseRenalfailure: clinicalDetails.chk_death_cause_renal,
                      DeathcauseOther: clinicalDetails.chk_death_cause_oth,
                      DeathcauseOthertext: clinicalDetails.txt_death_cause_oth,
                      DeathcauseUnknown: clinicalDetails.rb_death_cause_unk,

                      //16
                      Patienttype1yearPretransplantLocal: clinicalDetails.chk_pt_type_1yrpre_transplant_local,
                      Patienttype1yearPretransplantTraveling: clinicalDetails.chk_pt_type_1yrpre_transplant_travel,

                      Patienttype3monthStabilizationLocal: clinicalDetails.chk_pt_type_3months_stabilization_local,
                      Patienttype3monthStabilizationTraveling: clinicalDetails.chk_pt_type_3months_stabilization_travel,

                      PatienttypePoststabilizationLocal: clinicalDetails.chk_pt_type_post_stabilization_local,
                      PatienttypePoststabilizationTraveling: clinicalDetails.chk_pt_type_post_stabilization_travel,

                      Patienttype12monthPoststabilizationLocal: clinicalDetails.chk_pt_type_12monthpost_stabilization_local,
                      Patienttype12monthPoststabilizationTraveling: clinicalDetails.chk_pt_type_12monthpost_stabilization_travel,
                      //ST: 06/03/2025, sending for column show and hide for Q30. on  NonMDETreatment page, to delete column data if hidden.


                      PreTransplantStartEndCriteria: patientType_col1,

                      IndexDateThreeMonthCriteria: patientType_col2,
                      PostStabilizationTwelveMonthCriteria: patientType_col3,
                      TwelveMonthTwentyFourMonthCriteria: patientType_col4,
                  };

                  ToggleLoader(true);
                  const response = await clinicalCharacteristicService.SaveData(payload);
                  ToggleLoader(false);
                  if (response.status !== HTTPResponse.OK) {
                      if (response?.status === HTTPResponse.Unauthorized) {
                          HandleSessionTimeout();
                      } else throw response.error;
                  } else {
                      ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
                      await LoadData();
                      if (response) {
                          const { data } = response;

                          if (data) {
                              if (data.isAnyDateChanges)
                                  ShowAlertBox();

                              SetFields(data);
                          }
                      }
                  }
              }
          }
      return true;
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const ShowAlertBox = async () => {
     await ShowActionPopUp(
      "Alert",
      CommonError_Msgs.DateChangeAlert,
      "Ok",
      true
    );
  };

  const Validate = () => {
    let isValid = true;


    //12
    let clinical_trial_empty = false;
    let clinical_trial_dt_empty = false;
    let clinical_trial_dt_invalid = false;

    if (clinicalDetails.rbl_clinical_trial == null) {
      clinical_trial_empty = true;
    } else {
      if (clinicalDetails.rbl_clinical_trial === 2) {
        if (clinicalDetails.clinical_trial_start_dt == null) {
          clinical_trial_dt_empty = true;
        } else if (
          !IsDateEmpty(dates.indexDt) &&
          !IsDateEmpty(clinicalDetails.clinical_trial_start_dt) &&
          !DateValid(dates.indexDt, clinicalDetails.clinical_trial_start_dt)
        ) {
          clinical_trial_dt_invalid = true;
        }
      }
    }


    //13
    let first_encounter_dt_empty = false;
    let first_encounter_dt_invalid = false;
    let last_encounter_dt_empty = false;
    let last_encounter_dt_invalid = false;


    //first
    if (clinicalDetails.first_encounter_dt == null) {
      first_encounter_dt_empty = true;
    }

    if (clinicalDetails.first_encounter_dt !== null &&
      !IsDateEmpty(dates.indexDt) &&
      !IsDateEmpty(clinicalDetails.first_encounter_dt) &&
      !DateValid(clinicalDetails.first_encounter_dt, dates.indexDt)
    ) {
      first_encounter_dt_invalid = true;
    }
    // !IsValid(clinicalDetails.first_encounter_dt, dates.indexDt, clinicalDetails.last_encounter_dt, dates.surveyDt))

    if (clinicalDetails.first_encounter_dt !== null &&
      !IsDateEmpty(clinicalDetails.first_encounter_dt) &&
      !IsDateEmpty(clinicalDetails.last_encounter_dt) &&
      !DateValid(clinicalDetails.first_encounter_dt, clinicalDetails.last_encounter_dt)
    ) {
      first_encounter_dt_invalid = true;
    }
    //get current date
const today = new Date();
  let formattedDate = DisplayFormat(today)
    if (clinicalDetails.first_encounter_dt != null &&
      !IsDateEmpty(clinicalDetails.first_encounter_dt) &&
      !IsDateEmpty(formattedDate) &&
      !DateValid(clinicalDetails.first_encounter_dt, formattedDate)
    ) {
      first_encounter_dt_invalid = true;
    }

    if (clinicalDetails.first_encounter_dt !== null &&
      !IsDateEmpty(clinicalDetails.first_encounter_dt) &&
      !IsDateEmpty(formattedDate) &&
      !IsDateEmpty(dates.indexDt) &&
      !IsValid(clinicalDetails.first_encounter_dt, dates.indexDt, clinicalDetails.last_encounter_dt, formattedDate)
    ) {
      first_encounter_dt_invalid = true;
    }



    //last
    if (clinicalDetails.last_encounter_dt == null) {
      last_encounter_dt_empty = true;
    }
    if (
      !IsDateEmpty(clinicalDetails.last_encounter_dt) &&
      !IsDateEmpty(formattedDate) &&
      !DateValid(clinicalDetails.last_encounter_dt, formattedDate)) {
      last_encounter_dt_invalid = true;
    }


    if (
      !IsDateEmpty(clinicalDetails.last_encounter_dt) &&
      !IsDateEmpty(clinicalDetails.first_encounter_dt) &&
      !DateValid(clinicalDetails.first_encounter_dt, clinicalDetails.last_encounter_dt)) {
      last_encounter_dt_invalid = true;
    }


    if (
      !IsDateEmpty(clinicalDetails.last_encounter_dt) &&
      !IsDateEmpty(dates.indexDt) &&
      !DateValid(dates.indexDt, clinicalDetails.last_encounter_dt)) {
      last_encounter_dt_invalid = true;
    }


    if (
      !IsDateEmpty(clinicalDetails.last_encounter_dt) &&
      !IsDateEmpty(dates.indexDt) &&
      !IsDateEmpty(formattedDate) &&
      !IsDateInRange(clinicalDetails.last_encounter_dt, dates.indexDt, clinicalDetails.first_encounter_dt, formattedDate)) {
      last_encounter_dt_invalid = true;
    }


    //14
    let rbl_death_dt_empty = false;
    let death_dt_empty = false;
    let death_dt_invalid = false;

    if (clinicalDetails.rbl_death == null) {
      rbl_death_dt_empty = true;
    } else {
      if (clinicalDetails.rbl_death === 2) {
        if (clinicalDetails.death_dt == null) {
          death_dt_empty = true;
        }


        if (
          !IsDateEmpty(clinicalDetails.death_dt) &&
          !IsDateEmpty(dates.indexDt) &&
          !DateValid(dates.indexDt, clinicalDetails.death_dt)
          // !IsValid(dates.indexDt, clinicalDetails.last_encounter_dt, clinicalDetails.death_dt, dates.surveyDt)
        ) {
          death_dt_invalid = true;
        }


        if (
          !IsDateEmpty(clinicalDetails.death_dt) &&
          !IsDateEmpty(clinicalDetails.last_encounter_dt) &&
          !DateValid(clinicalDetails.last_encounter_dt, clinicalDetails.death_dt)
        ) {
          death_dt_invalid = true;
        }


        if (
          !IsDateEmpty(clinicalDetails.death_dt) &&
          !IsDateEmpty(dates.surveyDt) &&
          !DateValid(clinicalDetails.death_dt, dates.surveyDt)
        ) {
          death_dt_invalid = true;
        }


        if (
          !IsDateEmpty(clinicalDetails.death_dt) &&
          !IsDateEmpty(dates.surveyDt) &&
          !IsDateEmpty(dates.indexDt) &&
          !IsDateEmpty(clinicalDetails.last_encounter_dt) &&
          !IsValid(dates.indexDt, clinicalDetails.last_encounter_dt, clinicalDetails.death_dt, dates.surveyDt)
        ) {
          death_dt_invalid = true;
        }

      }
    }

    //15
    let death_cause_empty = false;
    if (clinicalDetails.rbl_death && clinicalDetails.rbl_death !== 1) {
      if ((!clinicalDetails.chk_death_cause_mde && !clinicalDetails.chk_death_cause_lt_lkt &&
        !clinicalDetails.chk_death_cause_oth && !clinicalDetails.rb_death_cause_unk) ||
        (clinicalDetails.chk_death_cause_oth && clinicalDetails.txt_death_cause_oth === "")
      ) {
        death_cause_empty = true;
      }
    }

    //16
    let pre_transplant_empty = false;
    if (
      patientType_col1 &&
      IsDateBefore(clinicalDetails.first_encounter_dt, dates.indexDt) &&
      clinicalDetails.chk_pt_type_1yrpre_transplant_local === false && clinicalDetails.chk_pt_type_1yrpre_transplant_travel === false) {
      pre_transplant_empty = true;
    }


    let three_month_stabilization_empty = false;
    if (
      patientType_col2 && IsGreaterOrEqual(dates.endofFollowUpDate, dates.indexDt) &&
      clinicalDetails.chk_pt_type_3months_stabilization_local === false && clinicalDetails.chk_pt_type_3months_stabilization_travel === false) {
      three_month_stabilization_empty = true;
    }

    let post_stabilization_empty = false;
    if (
      patientType_col3 && IsGreaterOrEqual(dates.endofFollowUpDate, dates.indexDtPlus92) &&
      clinicalDetails.chk_pt_type_post_stabilization_local === false && clinicalDetails.chk_pt_type_post_stabilization_travel === false) {
      post_stabilization_empty = true;
    }

    let twelve_month_post_stabilizationEmpty = false;
    if (
      patientType_col4 && IsGreaterOrEqual(dates.endofFollowUpDate, dates.indexDtPlus457) &&
      (!clinicalDetails.chk_pt_type_12monthpost_stabilization_local && !clinicalDetails.chk_pt_type_12monthpost_stabilization_travel)) {
      twelve_month_post_stabilizationEmpty = true;
    }

    setHardErrList((prev) => ({
      ...prev,


      clinical_trial_empty,
      clinical_trial_dt_empty,
      clinical_trial_dt_invalid,
      first_encounter_dt_empty,
      first_encounter_dt_invalid,
      last_encounter_dt_empty,
      last_encounter_dt_invalid,
      rbl_death_dt_empty,
      death_dt_empty,
      death_dt_invalid,
      death_cause_empty,
      pre_transplant_empty,
      three_month_stabilization_empty,
      post_stabilization_empty,
      twelve_month_post_stabilizationEmpty,

    }));

    if (
      clinical_trial_empty ||
      clinical_trial_dt_empty ||
      clinical_trial_dt_invalid ||
      first_encounter_dt_empty ||
      first_encounter_dt_invalid ||
      last_encounter_dt_empty ||
      last_encounter_dt_invalid ||
      rbl_death_dt_empty ||
      death_dt_empty ||
      death_dt_invalid ||
      death_cause_empty ||
      pre_transplant_empty ||
      three_month_stabilization_empty ||
      post_stabilization_empty ||
      twelve_month_post_stabilizationEmpty
    ) {
      isValid = false;
    }
    return isValid;
  };

  const HandleFieldChange = (e) => {
    const { name, value } = e.target;
    switch (name) {

      //Q12
      case "rbl_clinical_trial":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: Number(value),
            chk_clinical_trial_dt_est: false,
            clinical_trial_start_dt: null
          }));

          setHardErrList((prev) => ({
            ...prev,
            clinical_trial_empty: false,
            clinical_trial_dt_empty: false,
            clinical_trial_dt_invalid: false,
          }));
        }
        break;
      case "chk_clinical_trial_dt_est":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_clinical_trial: 2,
          }));

          setHardErrList((prev) => ({
            ...prev,
            clinical_trial_empty: false,
            clinical_trial_dt_empty: false,
            clinical_trial_dt_invalid: false,
          }));
        }
        break;


      //Q14      
      case "rbl_death":
        {
          setClinicalDetails(prev => {
            const updatedDetails = {
              ...prev,
              [name]: Number(value),
              death_dt: null,
              chk_death_dt_est: false,
            }
            //reset 14
            if (Number(value) === 1) {
              updatedDetails.chk_death_cause_mde = false;
              updatedDetails.chk_death_cause_lt_lkt = false;
              updatedDetails.chk_death_cause_oth = false;
              updatedDetails.txt_death_cause_oth = "";
              updatedDetails.rb_death_cause_unk = false;
            }
            return updatedDetails;
          })
          setDates(prev => ({
            ...prev,
            eighteenMonthFollowUpDt: GetEarliestDate(dates.indexPlus548Days, clinicalDetails.last_encounter_dt)
          }))
          setHardErrList(prev => {
            const updateData = {
              ...prev,
              rbl_death_dt_empty: false,
              death_dt_empty: false,
              death_dt_invalid: false,
            }
            //reset 14
            if (Number(value) === 1) {
              updateData.death_cause_empty = false;
            }
            return updateData;
          })
        }
        break;

      case "chk_death_dt_est":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rbl_death: 2,
          }));

          setHardErrList((prev) => ({
            ...prev,
            rbl_death_dt_empty: false,
            death_dt_empty: false,
            death_dt_invalid: false,
          }));
        }
        break;
      //15

      case "chk_death_cause_mde":
      case "chk_death_cause_lt_lkt":
        // case "chk_death_cause_renal":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            rb_death_cause_unk: false,
            // txt_death_cause_oth: ""

          }));
          setHardErrList(prev => ({
            ...prev,
            death_cause_empty: false
          }))
        }
        break;
      case "chk_death_cause_oth":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            txt_death_cause_oth: "",
            rb_death_cause_unk: false
          }));
          setHardErrList(prev => ({
            ...prev,
            death_cause_empty: false
          }))
        }
        break;
      case "txt_death_cause_oth":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: value,
            chk_death_cause_oth: true,
            rb_death_cause_unk: false
          }));
          setHardErrList(prev => ({
            ...prev,
            death_cause_empty: false
          }))
        }
        break;
      case "rb_death_cause_unk":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: !prev[name],
            chk_death_cause_mde: false,
            chk_death_cause_lt_lkt: false,
            // chk_death_cause_renal: false,
            chk_death_cause_oth: false,
            txt_death_cause_oth: ""
          }));
          setHardErrList(prev => ({
            ...prev,
            death_cause_empty: false
          }))
        }
        break;


      //16
      case "chk_pt_type_1yrpre_transplant_local":
      case "chk_pt_type_1yrpre_transplant_travel":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: !prev[name],

          }));
          setHardErrList(prev => ({
            ...prev,
            pre_transplant_empty: false
          }))
        }
        break;


      case "chk_pt_type_3months_stabilization_local":
      case "chk_pt_type_3months_stabilization_travel":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: !prev[name],

          }));
          setHardErrList(prev => ({
            ...prev,
            three_month_stabilization_empty: false
          }))
        }
        break;


      case "chk_pt_type_post_stabilization_local":
      case "chk_pt_type_post_stabilization_travel":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: !prev[name],

          }));
          setHardErrList(prev => ({
            ...prev,
            post_stabilization_empty: false
          }))
        }
        break;


      case "chk_pt_type_12monthpost_stabilization_local":
      case "chk_pt_type_12monthpost_stabilization_travel":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: !prev[name],

          }));
          setHardErrList(prev => ({
            ...prev,
            twelve_month_post_stabilizationEmpty: false
          }))
        }
        break;
      default:
        break;
    }



  };


  const HandleDateChange = (name, date) => {
    switch (name) {

      //12
      case "clinical_trial_start_dt":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: date,
            rbl_clinical_trial: 2,
          }));

          const updatedEndofFollowUp = GetEarliestDate(
            date,
            clinicalDetails.last_encounter_dt,
            clinicalDetails.death_dt
          );

          setDates(prev => ({
            ...prev,
            endofFollowUpDate: updatedEndofFollowUp
          }))

          const patientTypecol2 = IsGreaterOrEqual(updatedEndofFollowUp, dates.indexDt);
          setPatientType_col2(
            patientTypecol2
          );

          if (patientTypecol2 === false) {
            setClinicalDetails(prev => ({
              ...prev,
              chk_pt_type_3months_stabilization_local: false,
              chk_pt_type_3months_stabilization_travel: false,

            }))
          }


          const patientTypecol3 = IsGreaterOrEqual(updatedEndofFollowUp, dates.indexDtPlus92);
          setPatientType_col3(
            patientTypecol3
          );

          if (patientTypecol3 === false) {
            setClinicalDetails(prev => ({
              ...prev,
              chk_pt_type_post_stabilization_local: false,
              chk_pt_type_post_stabilization_travel: false,

            }))
          }

          const patientTypecol4 = IsGreaterOrEqual(updatedEndofFollowUp, dates.indexDtPlus457);

          setPatientType_col4(
            patientTypecol4
          );
          if (patientTypecol4 === false) {
            setClinicalDetails(prev => ({
              ...prev,
              chk_pt_type_12monthpost_stabilization_local: false,
              chk_pt_type_12monthpost_stabilization_travel: false,
            }))
          }

          setHardErrList((prev) => ({
            ...prev,
            clinical_trial_empty: false,
            clinical_trial_dt_empty: false,
            clinical_trial_dt_invalid: false,
          }));
        }
        break;
      //13
      case "first_encounter_dt":
        {
          setClinicalDetails(prev => ({
            ...prev,
            [name]: date
          }))

          //SYJ - 31/03/2025 - Changes => https://edotpulse.com/EditActionItem/AG-M-171 - Fix for date state not updating Correctly

          let indexMinus365Days = AdjustDays(dates.indexDt, -Values.value365);

          let most_recent_transplant_startdt = GetMaxDate(indexMinus365Days, date, demoBirthDate);

          setDates(prev => ({
            ...prev,
            oneYr_pretransplant_start: most_recent_transplant_startdt,
            beggining_follow_up: most_recent_transplant_startdt,
          }))

          const patientTypecol1 = IsDateBefore(date, dates.indexDt);
          setPatientType_col1(
            patientTypecol1
          );

          if (patientTypecol1 === false) {
            setClinicalDetails(prev => ({
              ...prev,
              chk_pt_type_1yrpre_transplant_local: false,
              chk_pt_type_1yrpre_transplant_travel: false,

            }))
          }




          setHardErrList(prev => ({
            ...prev,
            first_encounter_dt_empty: false,
            first_encounter_dt_invalid: false
          }))
        }
        break;

      case "last_encounter_dt":
        {
          setClinicalDetails(prev => ({
            ...prev,
            [name]: date
          }))

          const updatedEndofFollowUp = GetEarliestDate(
            clinicalDetails.clinical_trial_start_dt,
            date,
            clinicalDetails.death_dt
          );

          setDates(prev => ({
            ...prev,
            endofFollowUpDate: updatedEndofFollowUp
          }))

          const patientTypecol2 = IsGreaterOrEqual(updatedEndofFollowUp, dates.indexDt);
          setPatientType_col2(
            patientTypecol2
          );

          if (patientTypecol2 === false) {
            setClinicalDetails(prev => ({
              ...prev,
              chk_pt_type_3months_stabilization_local: false,
              chk_pt_type_3months_stabilization_travel: false,

            }))
          }
          const patientTypecol3 = IsGreaterOrEqual(updatedEndofFollowUp, dates.indexDtPlus92);
          setPatientType_col3(
            patientTypecol3
          );

          if (patientTypecol3 === false) {
            setClinicalDetails(prev => ({
              ...prev,
              chk_pt_type_post_stabilization_local: false,
              chk_pt_type_post_stabilization_travel: false,

            }))
          }

          const patientTypecol4 = IsGreaterOrEqual(updatedEndofFollowUp, dates.indexDtPlus457);
          setPatientType_col4(
            patientTypecol4
          );

          if (patientTypecol4 === false) {
            setClinicalDetails(prev => ({
              ...prev,
              chk_pt_type_12monthpost_stabilization_local: false,
              chk_pt_type_12monthpost_stabilization_travel: false,
            }))
          }

          setHardErrList(prev => ({
            ...prev,
            last_encounter_dt_empty: false,
            last_encounter_dt_invalid: false
          }))
        }
        break;


      //14
      case "death_dt":
        {
          setClinicalDetails((prev) => ({
            ...prev,
            [name]: date,
            rbl_death: 2,
          }));

          const patientTypecol2 = IsGreaterOrEqual(dates.endofFollowUpDate, dates.indexDt);
          setPatientType_col2(
            patientTypecol2
          );

          if (patientTypecol2 === false) {
            setClinicalDetails(prev => ({
              ...prev,
              chk_pt_type_3months_stabilization_local: false,
              chk_pt_type_3months_stabilization_travel: false,

            }))
          }
          const patientTypecol3 = IsGreaterOrEqual(dates.endofFollowUpDate, dates.indexDtPlus92);
          if (patientTypecol3 === false) {
            setClinicalDetails(prev => ({
              ...prev,
              chk_pt_type_post_stabilization_local: false,
              chk_pt_type_post_stabilization_travel: false,

            }))
          }

          const patientTypecol4 = IsGreaterOrEqual(dates.endofFollowUpDate, dates.indexDtPlus457);
          if (patientTypecol4 === false) {
            setClinicalDetails(prev => ({
              ...prev,
              chk_pt_type_12monthpost_stabilization_local: false,
              chk_pt_type_12monthpost_stabilization_travel: false,
            }))
          }


          setHardErrList((prev) => ({
            ...prev,
            rbl_death_dt_empty: false,
            death_dt_empty: false,
            death_dt_invalid: false,
          }));
        }
        break;

      default:
        break;
    }

  };




  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);

  //SYJ - 06/03/2025 - Fix for Localstorage data not getting updated when dates updated in this page.
  //SYJ - 17/03/2025 - commneted as the locastorage is now set from sidebarmenu ie is save value from db table are set in localstorage.
  // useEffect(() => {
  //   AddLocalStorageData("ClinicalCharacteristicsDates", dates);
  // }, [dates])

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>


      <section className="main-survey-section main-survey-button">
        <div >
          <SideBarMenu activePageId={SideMenuItems.ClinicalCharacteristics} />
          <>
            <button className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() => toggleSidebar(isSideMenuActive, setisSideMenuActive)}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className=" col-pad-left eligibiltylocked" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>CLINICAL CHARACTERISTICS</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}

              <div className="survey-question-section" disabled={patientLocked}>
                <div className="survey-question-content survey-content-box grey-bg">
                  <div className="question-answer grid-overflow">





                    <div className="block-margin">
                      <div>
                        <div className="custom-table custom-table-col">
                          <table>
                            {/* Q12. */}
                            <tr>
                              <td className="containertd">
                                <div className="question question-weight">
                                  <span>Q12.</span>
                                  <span className="quest-text-pad">
                                    Did the patient enroll in a clinical trial for <u>the treatment of MMA</u> after the index date? If so, please provide the start date of participation in this trial
                                  </span>
                                </div>
                              </td>
                              <td className="containertd">
                                <div>
                                  <div className="option-without-input">
                                    <label className="option-fbox">
                                      <input
                                        type="radio"
                                        id="rbl_clinical_trial_1"
                                        name="rbl_clinical_trial"
                                        value={1}
                                        checked={clinicalDetails.rbl_clinical_trial === 1}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>
                                        No, patient was not enrolled in a clinical trial for the treatment of MMA after the index date
                                      </span>
                                    </label>
                                  </div>

                                  <div className="option-fbox custom-top-padding">
                                    <input
                                      type="radio"
                                      id="rbl_clinical_trial_2"
                                      name="rbl_clinical_trial"
                                      value={2}
                                      checked={clinicalDetails.rbl_clinical_trial === 2}
                                      onChange={HandleFieldChange}
                                    />
                                    <span>
                                      <DateControl
                                        ctrlId={"clinical_trial_start_dt"}
                                        HandleDateChange={HandleDateChange}
                                        date={clinicalDetails.clinical_trial_start_dt}
                                      />
                                    </span>
                                  </div>
                                  <div className="estimated-date-padding text-margin">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_clinical_trial_dt_est"
                                        name="chk_clinical_trial_dt_est"
                                        checked={clinicalDetails.chk_clinical_trial_dt_est}
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Estimated Date
                                      </span>
                                    </label>
                                  </div>
                                  <div className="option-without-input">
                                    <label className="option-fbox">
                                      <input
                                        type="radio"
                                        id="rbl_clinical_trial_99"
                                        name="rbl_clinical_trial"
                                        value={99}
                                        checked={clinicalDetails.rbl_clinical_trial === 99}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>
                                        Patient enrolled in trial but date unknown
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={hardErrList.clinical_trial_empty}
                                  message={CommonError_Msgs.Msg1}
                                />
                                <ErrorField
                                  show={
                                    hardErrList.clinical_trial_dt_empty ||
                                    hardErrList.clinical_trial_dt_invalid
                                  }
                                  message={CommonError_Msgs.Msg2}
                                />
                              </td>
                            </tr>
                            {/* Q13 */}
                            <tr>

                              <td className="containertd custom-left-border-disabled custom-bottom-border-disabled relative-position">
                                <div className="question">
                                  <span className="question-weight">Q13.</span>
                                  <span className="quest-text-pad question-weight">
                                    Date of{" "}


                                    <span
                                      data-tooltip-id="encounterTip"
                                      className="modal-popup"
                                      onClick={() =>
                                        setShowHideHyperlinkModal(true)
                                      }
                                    >
                                      first and last patient record noted in the patient’s records.
                                    </span>
                                    <br />

                                    {showHideHyperlinkModal && (
                                      <InfoPopUp
                                        description={Last_Patient_Encounter}
                                        OkClick={() =>
                                          setShowHideHyperlinkModal(false)
                                        }
                                      />
                                    )}{" "}
                                  </span>
                                </div>
                              </td>
                              <td className="padding-zero">
                                <table className="nested-table">
                                  <thead>
                                    <th className="custom-enhanced-padding">Date of first patient record</th>
                                    <th className="custom-enhanced-padding">Date of last patient record</th>
                                  </thead>
                                  <tr>
                                    <td className="containertd relative-position">
                                      {/* <div className="floating-border"></div>
                                            <div className="floating-border-two"></div> */}
                                      <div className="">
                                        <div className="option-without-input">
                                          <span>
                                            <DateControl
                                              ctrlId={"first_encounter_dt"}
                                              HandleDateChange={HandleDateChange}
                                              date={clinicalDetails.first_encounter_dt}
                                            />
                                          </span>
                                        </div>
                                      </div>
                                      <ErrorField show={hardErrList.first_encounter_dt_empty || hardErrList.first_encounter_dt_invalid} message={CommonError_Msgs.Msg2} />

                                    </td>
                                    <td className="containertd">
                                      <div className="">
                                        <div className="option-without-input">
                                          <span>
                                            <DateControl
                                              ctrlId={"last_encounter_dt"}
                                              HandleDateChange={HandleDateChange}
                                              date={clinicalDetails.last_encounter_dt}
                                            />
                                          </span>
                                        </div>
                                      </div>
                                      <ErrorField show={hardErrList.last_encounter_dt_empty || hardErrList.last_encounter_dt_invalid} message={CommonError_Msgs.Msg2} />

                                    </td>
                                  </tr>
                                </table>
                              </td>


                            </tr>

                            {/* Q14 */}
                            <tr>
                              <td className="containertd">
                                <div className="question question-weight">
                                  <span>Q14.</span>
                                  <span className="quest-text-pad">
                                    Date of death
                                    <br />
                                    <br />
                                    <p>
                                      <b>Note:</b> the date of death, if applicable, should be on or after the date of last patient record (
                                      <span className="indigo-text">
                                        {clinicalDetails.last_encounter_dt || lastEncounterDtInit}
                                      </span>) and on or before the time of starting chart abstraction.
                                      {/* (
                                      <span className="indigo-text">
                                        {dates.surveyDt || surveyDtInit}
                                      </span>). */}
                                    </p>
                                  </span>
                                </div>
                              </td>
                              <td className="containertd">
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="option-fbox">
                                      <input
                                        type="radio"
                                        id="rbl_death_1"
                                        name="rbl_death"
                                        value={1}
                                        checked={clinicalDetails.rbl_death === 1}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>Patient is believed to be alive at the time of chart abstraction</span>
                                    </label>
                                  </div>

                                  <div className="custom-top-padding">
                                    <input
                                      type="radio"
                                      id="rbl_death_2"
                                      name="rbl_death"
                                      value={2}
                                      checked={clinicalDetails.rbl_death === 2}
                                      onChange={HandleFieldChange}
                                    />
                                    <span className="date-field-padding-left">
                                      <DateControl
                                        ctrlId={"death_dt"}
                                        HandleDateChange={HandleDateChange}
                                        date={clinicalDetails.death_dt}
                                      />
                                    </span>
                                  </div>
                                  <div className="estimated-date-padding text-margin">
                                    <label>
                                      <input
                                        type="checkbox"
                                        id="chk_death_dt_est"
                                        name="chk_death_dt_est"
                                        checked={clinicalDetails.chk_death_dt_est}
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Estimated Date
                                      </span>
                                    </label>
                                  </div>
                                  <div className="option-without-input">
                                    <label className="option-fbox">
                                      <input
                                        type="radio"
                                        id="death_99"
                                        name="rbl_death"
                                        value={99}
                                        checked={clinicalDetails.rbl_death === Values.value99}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>Patient died but date unknown</span>
                                    </label>
                                  </div>

                                </div>
                                <ErrorField show={hardErrList.death_dt_empty} message={CommonError_Msgs.Msg1} />
                                <ErrorField show={hardErrList.rbl_death_dt_empty || hardErrList.death_dt_invalid} message={CommonError_Msgs.Msg2} />
                              </td>
                            </tr>

                            {/* Q15 */}
                            {clinicalDetails.rbl_death && clinicalDetails.rbl_death !== 1 &&
                              <tr>
                                <td className="containertd">
                                  <div className="question question-weight">
                                    <span>Q15.</span>
                                    <span className="quest-text-pad">
                                      Cause of death
                                    </span>
                                  </div>
                                </td>
                                <td className="containertd">
                                  <div className="">
                                    <div className="option-without-input">
                                      <label className="optn-fbox">
                                        <input
                                          type="checkbox"
                                          id="chk_death_cause_mde"
                                          name="chk_death_cause_mde"
                                          checked={clinicalDetails.chk_death_cause_mde}
                                          onChange={HandleFieldChange}
                                        />
                                        <span>
                                          Complications of MDE
                                        </span>
                                      </label>
                                    </div>

                                    <div className="option-without-input">
                                      <label className="optn-fbox">
                                        <input
                                          type="checkbox"
                                          id="chk_death_cause_lt_lkt"
                                          name="chk_death_cause_lt_lkt"
                                          checked={clinicalDetails.chk_death_cause_lt_lkt}
                                          onChange={HandleFieldChange}
                                        />
                                        <span>
                                          LT/LKT-related transplant
                                          complication(s)
                                        </span>
                                      </label>
                                    </div>

                                    {/* <div className="option-without-input">
                                      <label className="optn-fbox">
                                        <input
                                          type="checkbox"
                                          id="chk_death_cause_renal"
                                          name="chk_death_cause_renal"
                                          checked={clinicalDetails.chk_death_cause_renal}
                                          onChange={HandleFieldChange}
                                        />
                                        <span>Renal failure or other renal complication </span>
                                      </label>
                                    </div> */}

                                    <div className="option-without-input">
                                      <label className="optn-fbox">
                                        <input
                                          type="checkbox"
                                          id="chk_death_cause_oth"
                                          name="chk_death_cause_oth"
                                          checked={clinicalDetails.chk_death_cause_oth}
                                          onChange={HandleFieldChange}
                                        />
                                        <span>Other, please specify: </span>
                                        {/* <input
                                          className="input-dash"
                                          type="text"
                                          id="txt_death_cause_oth"
                                          name="txt_death_cause_oth"
                                          value={clinicalDetails.txt_death_cause_oth}
                                          onChange={HandleFieldChange}
                                          maxLength={300}
                                        /> */}

                                      </label>
                                      <CustomTextArea
                                        id="txt_death_cause_oth"
                                        name="txt_death_cause_oth"
                                        value={clinicalDetails.txt_death_cause_oth}
                                        onChange={HandleFieldChange}
                                        styles={{ marginLeft: "30px", width: "85%" }}
                                      />
                                    </div>
                                    <div className="option-without-input">
                                      <label>
                                        <input
                                          type="radio"
                                          id="rb_death_cause_unk"
                                          name="rb_death_cause_unk"
                                          checked={clinicalDetails.rb_death_cause_unk}
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Unknown
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField show={hardErrList.death_cause_empty} message={CommonError_Msgs.Msg1} />
                                </td>
                              </tr>
                            }

                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="block-border white-bg" style={{ marginBlock: "20px 0" }}>
                      <div className="question">
                        <span className="question-weight">Q16.</span>
                        <span className="question-weight" style={{ paddingLeft: "10px" }}>We are interested in the patient’s continuity of care at your site before and after their LT/LKT procedure. Please indicate whether the patient was a local or traveling patient (or both) during the select time periods below.
                        </span>
                      </div>
                      <br />
                      <b>Please note that:</b>
                      <span className="note-type">
                        <ul>
                          <li>
                            <b>Local patient:</b> resides in the same or a surrounding state as the site; the patient has routine medical care at site
                          </li>
                          <li>
                            <b>Traveling patient:</b> requires significant travel to visit site or receives only part of their routine medical care at site or patients referred to site for transplant only (with transplant-related follow-up or check-up appointments) only
                          </li>

                        </ul>
                      </span>
                      <div className="custom-table">
                        <table className="custom-table-sec nested-table">
                          <thead>
                            <th>Target period</th>
                            <th>From <span className="indigo-text">  {dates?.oneYr_pretransplant_start || "1-year pre-transplant start"} </span> to  <span className="indigo-text">{dates?.oneYr_pretransplant_end || "1-year pre-transplant end"}</span></th>
                            <th>From <span className="indigo-text">{(dates.index_date || dates?.indexDt) || "index date"}</span> to <span className="indigo-text">{dates?.three_month_stabilization || "3-month stabilization date"}</span></th>
                            <th>From <span className="indigo-text">{dates?.post_stabilization_start || "Post-stabilization start date"}</span> to <span className="indigo-text">{dates?.twelve_month_post_stabilization || "12-month post-stabilization date"}</span></th>
                            <th>From <span className="indigo-text"> {dates?.twelve_month_post_stabilization_plusOneday || "12-month post-stabilization date + 1 day"}</span> to <span className="indigo-text">{dates?.twenty_four_months_post_stabilization || "24-month post-stabilization date"}</span></th>

                          </thead>
                          <tr>
                            <td>Patient type</td>
                            <td className="containertd">
                              {!patientType_col1 ? (
                                <span  ><b>Not Applicable</b></span>
                              ) : (
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="optn-fbox">
                                      <input
                                        type="checkbox"
                                        id="chk_pt_type_1yrpre_transplant_local"
                                        name="chk_pt_type_1yrpre_transplant_local"
                                        checked={clinicalDetails.chk_pt_type_1yrpre_transplant_local}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>
                                        Local
                                      </span>
                                    </label>
                                  </div>

                                  <div className="option-without-input">
                                    <label className="optn-fbox">
                                      <input
                                        type="checkbox"
                                        id="chk_pt_type_1yrpre_transplant_travel"
                                        name="chk_pt_type_1yrpre_transplant_travel"
                                        checked={clinicalDetails.chk_pt_type_1yrpre_transplant_travel}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>
                                        Traveling
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              )}
                              <ErrorField show={hardErrList.pre_transplant_empty} message={CommonError_Msgs.Msg1} />
                            </td>



                            <td className="containertd">
                              {!patientType_col2 ? (
                                <span ><b>Not Applicable</b></span>
                              ) : (
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="optn-fbox">
                                      <input
                                        type="checkbox"
                                        id="chk_pt_type_3months_stabilization_local"
                                        name="chk_pt_type_3months_stabilization_local"
                                        checked={clinicalDetails.chk_pt_type_3months_stabilization_local}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>
                                        Local
                                      </span>
                                    </label>
                                  </div>

                                  <div className="option-without-input">
                                    <label className="optn-fbox">
                                      <input
                                        type="checkbox"
                                        id="chk_pt_type_3months_stabilization_travel"
                                        name="chk_pt_type_3months_stabilization_travel"
                                        checked={clinicalDetails.chk_pt_type_3months_stabilization_travel}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>
                                        Traveling
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              )}
                              <ErrorField show={hardErrList.three_month_stabilization_empty} message={CommonError_Msgs.Msg1} />
                            </td>


                            <td className="containertd">
                              {!patientType_col3 ? (
                                <span  ><b>Not Applicable</b></span>
                              ) : (
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="optn-fbox">
                                      <input
                                        type="checkbox"
                                        id="chk_pt_type_post_stabilization_local"
                                        name="chk_pt_type_post_stabilization_local"
                                        checked={clinicalDetails.chk_pt_type_post_stabilization_local}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>
                                        Local
                                      </span>
                                    </label>
                                  </div>

                                  <div className="option-without-input">
                                    <label className="optn-fbox">
                                      <input
                                        type="checkbox"
                                        id="chk_pt_type_post_stabilization_travel"
                                        name="chk_pt_type_post_stabilization_travel"
                                        checked={clinicalDetails.chk_pt_type_post_stabilization_travel}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>
                                        Traveling
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              )}
                              <ErrorField show={hardErrList.post_stabilization_empty} message={CommonError_Msgs.Msg1} />
                            </td>

                            <td className="containertd">
                              {!patientType_col4 ? (
                                <span  ><b>Not Applicable</b></span>
                              ) : (
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="optn-fbox">
                                      <input
                                        type="checkbox"
                                        id="chk_pt_type_12monthpost_stabilization_local"
                                        name="chk_pt_type_12monthpost_stabilization_local"
                                        checked={clinicalDetails.chk_pt_type_12monthpost_stabilization_local}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>
                                        Local
                                      </span>
                                    </label>
                                  </div>

                                  <div className="option-without-input">
                                    <label className="optn-fbox">
                                      <input
                                        type="checkbox"
                                        id="chk_pt_type_12monthpost_stabilization_travel"
                                        name="chk_pt_type_12monthpost_stabilization_travel"
                                        checked={clinicalDetails.chk_pt_type_12monthpost_stabilization_travel}
                                        onChange={HandleFieldChange}
                                      />
                                      <span>
                                        Traveling
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              )}
                              <ErrorField show={hardErrList.twelve_month_post_stabilizationEmpty} message={CommonError_Msgs.Msg1} />
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>


                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ClinicalCharacteristics;
